import styled from 'styled-components';

import { token } from '@zillow/constellation';

export const StyledContainer = styled.div`
    width: 100%;
    border: 1px solid ${token('colors.gray300')};
    border-radius: 5px;
`;

export const StyledSummaryBox = styled.div`
    text-align: center;
    padding: 32px 0;
`;
